import * as Yup from "yup";
import profileFormModel from "./profileFormModel";

const {
  formField: {
    clientFullName,
    registeredMobileNo,
    registeredEmailAddress,
    clientGender,
    clientAge,
    clientCode,
    city,
    nomineeFullName,
    state,
    insurancePolicies,
    trading,
    investment,
    mutualFunds,
    tradingPreferences,
  },
} = profileFormModel;

export default [
  // Step 0 validation (client details section)
  Yup.object().shape({
    clientDetails: Yup.object().shape({
      [clientFullName.name.split(".")[1]]: Yup.string().required(
        clientFullName.requiredErrorMsg
      ),
      [registeredMobileNo.name.split(".")[1]]: Yup.string().matches(
        /^[0-9]{10}$/,
        "Mobile number must be exactly 10 digits"
      ),
      [registeredEmailAddress.name.split(".")[1]]: Yup.string()
        .trim()
        .lowercase()
        .email("Enter a valid email")
        .required(registeredEmailAddress.requiredErrorMsg),
      [clientGender.name.split(".")[1]]: Yup.string().required(
        clientGender.requiredErrorMsg
      ),
      [clientAge.name.split(".")[1]]: Yup.number()
        .typeError("Age must be a number")
        .required(clientAge.requiredErrorMsg)
        .min(0, "Age must be positive"),
      [city.name.split(".")[1]]: Yup.string().required(city.requiredErrorMsg),
      [nomineeFullName.name.split(".")[1]]: Yup.string(), // optional
      [state.name.split(".")[1]]: Yup.string().required(state.requiredErrorMsg),
    }),
  }),

  // Step 1 validation (monthly income section) - no required fields
  Yup.object().shape({}),

  // Step 2 validation (monthly expenses section) - no required fields
  Yup.object().shape({}),

  // Step 3 validation (asset list section) - no required fields
  Yup.object().shape({}),

  // Step 4 validation (liability list section) - no required fields
  Yup.object().shape({}),

  // Step 5 validation (trading and investment section)
  Yup.object().shape({
    tradingAndInvestment: Yup.object().shape({
      [trading.name.split(".")[1]]: Yup.array()
        .of(Yup.string())
        .min(1, trading.requiredErrorMsg)
        .required(trading.requiredErrorMsg),
      [investment.name.split(".")[1]]: Yup.array()
        .of(Yup.string())
        .min(1, investment.requiredErrorMsg)
        .required(investment.requiredErrorMsg),
      [tradingPreferences.name.split(".")[1]]: Yup.array().of(Yup.string()), // optional
    }),
  }),

  // Step 6 validation (insurance coverage section — optional fields)
  Yup.object().shape({
    insuranceCoverage: Yup.object().shape({
      [insurancePolicies.name.split(".")[1]]: Yup.array().of(
        Yup.object().shape({
         name: Yup.string(),
          providerCompanyName: Yup.string(),
          policyValue: Yup.number()
            .typeError("Must be a number")
            .min(0, "Policy value must be positive")
            .optional(),
        })
      ),
    }),
  }),

  // Step 7 validation (monthly saving section) - no required fields
  Yup.object().shape({}),
];
